export const SPECIALTIES: string[] = [
  'Psicologia',
  'Fisioterapia',
  'Fonoaudiologia',
  'Nutrição',
  'Terapia Ocupacional',
  'Psicopedagogia',
  'Odontologia',
  'Clínicas multidisciplinares',
];

export interface Faq {
  q: string;
  a: string;
}

export const HOME_FAQ: Faq[] = [
  {
    q: 'Como funciona a cobrança do sistema?',
    a: 'A cobrança é feita de acordo com a assinatura da sua clínica, sem limite de pacientes cadastrados.',
  },
  {
    q: 'Meus dados ficam seguros?',
    a: 'Sim. Cada clínica tem seus dados completamente isolados dos de outras clínicas na plataforma, com controle de acesso por perfil de usuário.',
  },
  {
    q: 'Dá pra acessar de mais de um computador ou celular?',
    a: 'Sim, o sistema roda direto no navegador, sem instalação — acessa de qualquer computador, tablet ou celular com internet.',
  },
  {
    q: 'Como faço pra contratar o Sistema Neurobit?',
    a: 'É só falar com a gente pelo botão "Fale Conosco", a implantação é feita junto com a nossa equipe.',
  },
];
